export default __webpack_public_path__ + "static/media/Community-living-insurance-policy-2025.5863cba6.pdf";